module.exports = __webpack_public_path__ + "img/image-01.ce652538.jpeg";